import React from "react";
import styles from "./AboutCard.module.scss";
import storyImg from "../../../../assets/images/landingPage/about/story.png";
import reliabilityImg from "../../../../assets/images/landingPage/about/reliability.png";
import convenienceImg from "../../../../assets/images/landingPage/about/convenience.png";

const data = [
  {
    enable: true,
    img: storyImg,
    heading: "Story",
    content:
      "Gaining knowledge is a continuous journey. Why not turn the journey into an experience by means of simplified story telling, where science gets conveyed artistically to you.",
  },
  {
    enable: true,
    img: reliabilityImg,
    heading: "Reliability",
    content:
      "Senior Cardiologists of India sharing their mind space, content from trusted publishing partners. What can be more reliable?",
  },
  {
    enable: true,
    img: convenienceImg,
    heading: "Convenience",
    content:
      "What better format than videos to consume the content delivered with AI driven personalization.",
  },
];
const AboutCard = () => {
  return (
    <div className={styles.container}>
      {data.map(
        ({ heading, img, content, enable }) =>
          enable && (
            <div key={heading} className={styles.card}>
              <div className={styles.img}>
                <img src={img} alt="" height="100%" width="100%" />
              </div>
              <div className={styles.heading}>{heading}</div>
              <div className={styles.content}>{content}</div>
            </div>
          )
      )}
    </div>
  );
};

export default AboutCard;
